// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonMessages = {
  copied: "已复制",
  copyFailed: "复制失败",
  loading: "加载中...",
  requestFailed: "请求失败，请稍后重试",
  loadFailed: "加载失败",
  totalCount: "共 {count} 条",
  selectedCount: "已选 {count} 项",
  selectedAllCount: "已选择 {count} 项",
  selectedPartialCount: "已选择前 {selected} 项（当前筛选共 {total} 项，超出部分未选中）",
  idNumber: "ID #{id}",
} as const;
